import { observable, action } from 'mobx'

class TaskStore {
    @observable ppePlayerList
    @observable unionTeamList

    @action
    addPpePlayer = info => {
        this.ppePlayerList.push(info)
    }

    @action
    delPpePlayer = indexno => {
        let ppePlayerList = []
        for (let i = 0; i < this.ppePlayerList.length; i++) {
            if (this.ppePlayerList[i].indexno !== indexno) {
                ppePlayerList.push(this.ppePlayerList[i])
            }
        }
        this.ppePlayerList = ppePlayerList
    }

    @action
    clearPpePlayer = (list = []) => {
        this.ppePlayerList = list
    }

    @action
    addUnionTeam = info => {
        this.unionTeamList.push(info)
    }

    @action
    delUnionTeam = teamno => {
        let unionTeamList = []
        for (let i = 0; i < this.unionTeamList.length; i++) {
            if (this.unionTeamList[i].teamno !== teamno) {
                unionTeamList.push(this.unionTeamList[i])
            }
        }
        this.unionTeamList = unionTeamList
    }

    @action
    clearUnionTeam = () => {
        this.unionTeamList = []
    }

    constructor () {
        this.ppePlayerList = []
        this.unionTeamList = []
    }
}

export default new TaskStore()



// WEBPACK FOOTER //
// ./src/store/task-form.js